/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { defineComponent, onMounted, getCurrentInstance, nextTick, createVNode } from 'vue';
import circleAdapter from '../../_common/js/loading/circle-adapter.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import '../../_chunks/dep-a26b9c60.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-f7837681.mjs';
import '../../_chunks/dep-6bcce672.mjs';
import '../../_chunks/dep-9c7a32ff.mjs';
import '../../_chunks/dep-89b33ff6.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-c45cdd10.mjs';
import '../../_chunks/dep-ce88e3c0.mjs';
import '../../_chunks/dep-a432d90f.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-493c38ce.mjs';
import '../../_chunks/dep-b56b2dc0.mjs';
import '../../_chunks/dep-77f634fb.mjs';
import '../../_chunks/dep-28ae3cda.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-7211604f.mjs';
import '../../_chunks/dep-75df64b1.mjs';
import '../../_chunks/dep-48b9a098.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-52c1d6a9.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-6043e9fc.mjs';
import '../../_chunks/dep-3a045465.mjs';
import '../../_chunks/dep-53dc0ac1.mjs';
import '../../_chunks/dep-b6b4eaa3.mjs';
import '../../_chunks/dep-881cffb7.mjs';
import '../../_chunks/dep-436b338d.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-2d31a683.mjs';
import '../../_chunks/dep-3ddc95d0.mjs';
import '../../config-provider/type.mjs';

var GradientIcon = defineComponent({
  name: "TLoadingGradient",
  setup: function setup() {
    var classPrefix = usePrefixClass();
    onMounted(function () {
      var circleElem = getCurrentInstance().refs.circle;
      nextTick(function () {
        circleAdapter(circleElem);
      });
    });
    return {
      classPrefix: classPrefix
    };
  },
  render: function render() {
    var classPrefix = this.classPrefix;
    var name = "".concat(classPrefix, "-loading__gradient");
    var classes = [name, "".concat(classPrefix, "-icon-loading")];
    return createVNode("svg", {
      "class": classes,
      "viewBox": "0 0 12 12",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }, [createVNode("foreignObject", {
      "x": "0",
      "y": "0",
      "width": "12",
      "height": "12"
    }, [createVNode("div", {
      "class": "".concat(name, "-conic"),
      "ref": "circle"
    }, null)])]);
  }
});

export { GradientIcon as default };
//# sourceMappingURL=gradient.mjs.map
